<div class="row">
  @for (field of config.fields; track field) {
    @if((field | formFieldShow: currentData)) {
      <div class="{{field.containerClass}}">

        @switch (field.type) {
          @case (FormFieldType.DIVIDER) {
            <div>
              <mat-divider/>
              <br/>
            </div>
          }
          @case (FormFieldType.TITLE) {
            <div>
              <h3>{{ field.label }}</h3>
            </div>
          }
          @case (FormFieldType.EXPRESSION) {
            <app-field-expression
              [label]="field.label"
              [placeholder]="field.placeholder"
              [value]="(valueRecord[field.key || ''])"
              [inputOptionsUrl]="field.optionsGateway? field.optionsGateway + '/choice' : field.optionsUrl"
              [inputOptionsFilter]="field.filterOptions"
              [mode]="field.mode"
              [errors]="errors | formDataSetRenderError: field"
              (valueChange)="setValue(field.key || '', $event)"
            />
          }
          @case (FormFieldType.IMAGE) {
            <app-field-image
              [label]="field.label"
              [placeholder]="field.placeholder"
              [value]="(valueRecord[field.key || ''])"
              [mode]="field.mode"
              (valueChange)="setValue(field.key || '', $event)"
              [errors]="errors | formDataSetRenderError: field"
            />
          }
          @case (FormFieldType.OPTIONS) {
            <app-field-select
              [label]="field.label"
              [optionsUrl]="field.optionsGateway? field.optionsGateway + '/choice' : field.optionsUrl"
              [optionConfigKey]="field.optionsConfigKey"
              [optionsUrlInvert]="field.optionsGateway? (field.optionsGateway + '/choice') : (field.optionsInvertUrl ? field.optionsInvertUrl : (field.optionsUrl ? (field.optionsUrl + '/invert'): null))"
              [options]="field.options"
              [filter]="field.filterOptions"
              [placeholder]="field.placeholder"
              [errors]="errors | formDataSetRenderError: field"
              [value]="(valueRecord[field.key || ''] || '').toString()"
              (valueChange)="setValue(field.key || '', $event)"
            />
          }
          @case (FormFieldType.OPTIONS_MULTIPLE) {
            <app-field-select-multiple
              [label]="field.label"
              [optionsUrl]="field.optionsGateway? field.optionsGateway + '/choice' : field.optionsUrl"
              [optionConfigKey]="field.optionsConfigKey"
              [optionsUrlInvert]="field.optionsGateway? (field.optionsGateway + '/choice') : (field.optionsInvertUrl ? field.optionsInvertUrl : (field.optionsUrl ? (field.optionsUrl + '/invert'): null))"
              [options]="field.options"
              [placeholder]="field.placeholder"
              [filter]="field.filterOptions"
              [value]="valueRecord[field.key || '']"
              (valueChange)="setValue(field.key || '', $event)"
              [errors]="errors | formDataSetRenderError: field"
            />
          }
          @case (FormFieldType.DATE_RANGE) {
            <app-field-date-range
              [label]="field.label"
              [placeholder]="field.placeholder"
              [startValue]="(valueRecord[(field.keys || [])[0] || ''] || '').toString()"
              [endValue]="(valueRecord[(field.keys || [])[1] || ''] || '').toString()"
              [errors]="errors | formDataSetRenderError: field"

              (startValueChange)="setValue((field.keys || [])[0] || '', $event)"
              (endValueChange)="setValue((field.keys || [])[1] || '', $event)"
            />
          }
          @case (FormFieldType.NUMBER) {
            <app-field-number
              [label]="field.label"
              [placeholder]="field.placeholder"
              [errors]="errors | formDataSetRenderError: field"
              [value]="(valueRecord[field.key || ''] || '').toString()"

              (valueChange)="setValue(field.key || '', $event)"
            />
          }
          @case (FormFieldType.PHONE) {
            <app-field-phone
              [label]="field.label"
              [placeholder]="field.placeholder"
              [errors]="errors | formDataSetRenderError: field"
              [value]="(valueRecord[field.key || ''] || '').toString()"

              (valueChange)="setValue(field.key || '', $event)"
            />
          }
          @case (FormFieldType.BOOLEAN) {
            <div class="m-b-30">
              <mat-slide-toggle
                color="success"
                [checked]="toBoolean(valueRecord[field.key || ''])"
                (change)="setValue(field.key || '', $event.checked)"
              >
                {{ field.label }}
              </mat-slide-toggle>
            </div>
          }
          @case (FormFieldType.DATE_TIME) {
            <app-field-date-time
              [label]="field.label"
              [placeholder]="field.placeholder"
              [value]="(valueRecord[field.key || ''] || '').toString()"
              (valueChange)="setValue(field.key || '', $event)"
              [errors]="errors | formDataSetRenderError: field"
              [image]="field.image"
            />
          }
          @case (FormFieldType.DATE) {
            <app-field-date
              [label]="field.label"
              [placeholder]="field.placeholder"
              [value]="(valueRecord[field.key || ''] || '').toString()"
              (valueChange)="setValue(field.key || '', $event)"
              [errors]="errors | formDataSetRenderError: field"
              [image]="field.image"
            />
          }
          @case (FormFieldType.PASSWORD) {
            <app-field-password
              [label]="field.label"
              [placeholder]="field.placeholder"
              [value]="(valueRecord[field.key || ''] || '').toString()"
              (valueChange)="setValue(field.key || '', $event)"
              [errors]="errors | formDataSetRenderError: field"
              [image]="field.image"
            />
          }
          @case (FormFieldType.EMAIL) {
            <app-field-email
              [label]="field.label"
              [placeholder]="field.placeholder"
              [value]="(valueRecord[field.key || ''] || '').toString()"
              (valueChange)="setValue(field.key || '', $event)"
              [errors]="errors | formDataSetRenderError: field"
              [image]="field.image"
            />
          }
          @case (FormFieldType.GEO_JSON) {
            <app-field-map-draw
              [label]="field.label"
              [placeholder]="field.placeholder"
              [value]="(valueRecord[field.key || ''] || '')"
              (valueChange)="setValue(field.key || '', $event)"
              [errors]="errors | formDataSetRenderError: field"
            />
          }
          @default {
            <app-field-text
              [label]="field.label"
              [placeholder]="field.placeholder"
              [value]="(valueRecord[field.key || ''] || '').toString()"
              (valueChange)="setValue(field.key || '', $event)"
              [errors]="errors | formDataSetRenderError: field"
              [image]="field.image"
            />
          }
        }
      </div>
    }
  }

  @if (!config.hideSubmit) {
    <div class="col-12">
      <br />
      <br />
      <mat-divider></mat-divider>
      <br />
      <br />
    </div>

    <div class="col-12 col-md-3">
      <div class="grid">
        <button
          mat-flat-button color="primary"
          class="mat-body f-w-500"
          [disabled]="isSubmitting"
          (click)="onSubmit('list')"
        >
          @if (isSubmitting) {
            {{ 'Guardando ...' }}
          } @else {
            {{ 'Guardar y listar' }}
          }
        </button>
      </div>
    </div>
  }
</div>



